import { useNavigate } from "react-router-dom";
import { IoArrowBack, IoChevronDown } from "react-icons/io5";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import cindyGuan from "../../assets/ourteam/cindy_guan.jpg";
import sharmanneBongolan from "../../assets/ourteam/sharmanne_bongolan.jpeg";
import mickyRai from "../../assets/ourteam/micky_rai.jpeg";
import rebeccaGordon from "../../assets/ourteam/rebecca_gordon.png";

const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1536 },
        items: 4.5,
        slidesToSlide: 1,
    },
    laptop: {
        breakpoint: { max: 1536, min: 1200 },
        items: 4.5,
        slidesToSlide: 1,
    },
    tablet: {
        breakpoint: { max: 1200, min: 768 },
        items: 4.5,
        slidesToSlide: 1,
    },
    smallTablet: {
        breakpoint: { max: 768, min: 640 },
        items: 2.5,
        slidesToSlide: 1,
    },
    mobile: {
        breakpoint: { max: 640, min: 0 },
        items: 1.5,
        slidesToSlide: 1,
    },
};

const OurTeam = () => {
    const navigate = useNavigate();

    const ourTeam = [
        {
            name: "Micky Rai",
            role: "Founder & CEO",
            image: mickyRai
        },
        {
            name: "Sharmanne Bongolan",
            role: "Product Designer",
            image: sharmanneBongolan
        },
        {
            name: "Rebecca Gordon",
            role: "Product Designer",
            image: rebeccaGordon
        },
        {
            name: "Cindy Guan",
            role: "Product Designer",
            image: cindyGuan
        },
    ];

    return (
        <section className="flex h-full w-full flex-col overflow-y-auto px-5 py-6 sm:px-8 lg:px-10 lg:py-8 no-scrollbar">
            {/* Back arrow — mobile only */}
            <button
                onClick={() => navigate(-1)}
                className="flex md:hidden items-center gap-1.5 mb-4"
            >
                <IoArrowBack className="text-[22px]" />
            </button>

            <button className="w-fit rounded-[10px] border border-[#7FC7E6] px-7 py-2.5 text-[15px] font-semibold text-[#139AC3]">
                Our team
            </button>

            <h2 className="mt-8 max-w-[560px] text-[32px] font-black leading-[1.05] tracking-[-0.02em] text-[#1f2328] sm:text-[40px]">
                Built by a small team
                <br />
                who wanted better.
            </h2>

            <div className="mt-12 w-full">
                <Carousel
                    swipeable
                    draggable
                    infinite={false}
                    keyBoardControl
                    showDots={false}
                    containerClass="pb-2"
                    responsive={responsive}
                    itemClass="pr-3 sm:pr-4"
                    removeArrowOnDeviceType={["desktop", "laptop", "tablet", "smallTablet", "mobile"]}
                >
                    {ourTeam.map((member, index) => (
                        <div key={index} className="w-full">
                            <img
                                src={member.image}
                                alt={member.name}
                                className="h-[300px] w-full rounded-[24px] object-cover sm:h-[330px]"
                                draggable={false}
                            />
                            <div className="mt-3 min-h-[104px] pl-2">
                                <h2 className="text-[18px] font-semibold leading-[1.02] text-[#242424] whitespace-nowrap">
                                    {member.name}
                                </h2>
                                <p className="mt-1 text-[17px] leading-[1.02] text-[#4B4B4B] whitespace-nowrap">
                                    {member.role}
                                </p>
                            </div>
                        </div>
                    ))}
                </Carousel>
            </div>

            <div className="mt-auto flex items-center justify-center pt-8 pb-3 sm:pb-5">
                <button
                    onClick={() => navigate("/about-us/get-early-access")}
                    className="flex items-center gap-1.5 text-[14px] font-semibold text-[#2E9DDA] hover:underline"
                >
                    Get early access when we launch
                    <IoChevronDown className="text-[15px]" />
                </button>
            </div>
        </section>
    );
};

export default OurTeam;
